import WebGLLine from '../primitives/WebGLLine';
import WebGLTriangle from '../primitives/WebGLTriangle';
import CompositeShape from '../CompositeShape';

export default class WebGLArrow extends CompositeShape {

	public constructor (private shaft: WebGLLine, private head: WebGLTriangle) {
		super();
	}

	/*
	 * Factory methods
	 */

	public static fromNumbers (x1: number, y1: number, x2: number, y2: number) {
		const shaft = WebGLLine.fromNumbers(x1, y1, x2, y2);
		const head = this.createHead(shaft);

		return new WebGLArrow(shaft, head);
	}

	public copy () {
		return new WebGLArrow(this.shaft.copy(), this.head.copy());
	}

	/*
	 * Protected methods
	 */

	public getComponents () {
		return [this.shaft, this.head];
	}

	/*
	 * Private methods
	 */

	private static createHead (shaft: WebGLLine) {
		const x2 = shaft.getX2();
		const y2 = shaft.getY2();

		const xDiff = x2 - shaft.getX1();
		const yDiff = y2 - shaft.getY1();

		if (xDiff === 0 && yDiff === 0) {
			return new WebGLTriangle(x2, y2, x2, y2, x2, y2);
		}

		let angle: number;

		if (xDiff === 0) {
			angle = Math.PI / 2 * (yDiff < 0 ? -1 : 1);

		} else {
			angle = Math.atan(yDiff / xDiff);

			if (xDiff < 0) {
				angle += Math.PI;
			}
		}

		const delta = .4;
		const anglePlusDelta = angle + Math.PI + delta;
		const angleMinusDelta = angle + Math.PI - delta;

		const arrowHeadLength = .04;

		const x1 = x2 + Math.cos(anglePlusDelta) * arrowHeadLength;
		const y1 = y2 + Math.sin(anglePlusDelta) * arrowHeadLength;
		const x3 = x2 + Math.cos(angleMinusDelta) * arrowHeadLength;
		const y3 = y2 + Math.sin(angleMinusDelta) * arrowHeadLength;

		return new WebGLTriangle(x1, y1, x2, y2, x3, y3);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/shapes/composites/WebGLArrow.ts